<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.Configuration.Consultation'
}
</script>

<style scoped>

</style>
